import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

/**
 * Generic configurable button for use in formly scripts.
 * The click behavior is driven by `props.action` and a matching callback
 * in `formState`, keeping this component free of app-specific service dependencies.
 *
 * Props:
 *   label    — button text (default: 'Go Back')
 *   icon     — FontAwesome icon array, e.g. ["fass", "arrow-left"] (optional)
 *   color    — Material button color: 'primary' | 'accent' | 'warn' (optional)
 *   variant  — 'raised' (default) | 'flat' | 'stroked' | 'basic'
 *   action   — 'navBack' | 'navTo' — which formState callback to invoke on click
 *   navTo    — auxOutlet name; required when action === 'navTo'
 *
 * The host component populates formState with the corresponding callbacks:
 *   formState.navBack()           — called when action === 'navBack'
 *   formState.navTo(outlet)       — called when action === 'navTo'
 */
@Component({
	selector: 'app-mat-formly-button',
	templateUrl: './mat-formly-button.component.html',
	styleUrls: ['./mat-formly-button.component.scss'],
	standalone: false
})
export class MatFormlyButtonComponent extends FieldType<FieldTypeConfig> {
	public onClick(): void {
		const action = this.props['action'] as string;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const formState = (this.options as any)?.formState;

		if (action === 'navBack') {
			formState?.navBack?.();
		} else if (action === 'navTo') {
			formState?.navTo?.(this.props['navTo']);
		}
	}
}
